const normalizeDisplayValue = (value) => {
  if (typeof value === 'string') {
    return value.toLowerCase();
  }

  return '';
};

export const getSelectedMonetizationResultIds = ({
  headers = [],
  rows = [],
  selectedRowIds = [],
}) => {
  const platformIndex = headers.findIndex(({ display }) => display === 'Platform');

  if (platformIndex === -1 || selectedRowIds.length === 0) {
    return {
      eligibleIds: [],
      hasSelection: selectedRowIds.length > 0,
      allSelectedEligible: false,
    };
  }

  const selectedIdSet = new Set(selectedRowIds);
  const selectedRows = rows.filter((rowData = []) => {
    const editableCell = rowData.find((cell) => cell?.editableId);
    return editableCell && selectedIdSet.has(editableCell.editableId);
  });

  const eligibleIds = selectedRows
    .filter((rowData = []) => {
      const editableCell = rowData.find((cell) => cell?.editableId);
      const platformCell = rowData[platformIndex];
      return Boolean(
        editableCell
        && normalizeDisplayValue(platformCell?.display).includes('youtube'),
      );
    })
    .map((rowData) => rowData.find((cell) => cell?.editableId)?.editableId)
    .filter(Boolean);

  return {
    eligibleIds,
    hasSelection: selectedRows.length > 0,
    allSelectedEligible: selectedRows.length > 0 && eligibleIds.length === selectedRows.length,
  };
};

export default getSelectedMonetizationResultIds;
